import { Phone, Mail, Facebook } from "lucide-react";
import { BUSINESS } from "@/lib/business";

export const Footer = () => (
  <footer data-testid="footer" className="relative bg-[#0A0A0A] border-t border-white/5 pt-20 pb-10">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
        <div className="md:col-span-5">
          <img
            src="/logos/optima-logo.png"
            alt="Optima Electrical Solutions Ltd"
            className="h-16 w-auto object-contain mb-6"
          />
          <p className="text-[#A0AAB2] text-sm leading-relaxed max-w-md">
            Qualified, insured and trusted electricians serving Medway and the
            surrounding areas of Kent. Honest pricing, certified work, real care.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] tracking-[0.3em] text-[#1E90FF] uppercase mb-5">Navigate</div>
          <ul className="space-y-3 text-sm">
            {["Services", "About", "Service Areas", "Reviews", "Contact"].map((l) => (
              <li key={l}>
                <a
                  href={`#${l.toLowerCase().replace(/\s/g, "")}`}
                  className="text-[#A0AAB2] hover:text-white transition-colors"
                  data-testid={`footer-nav-${l.toLowerCase().replace(/\s/g, "-")}`}
                >
                  {l}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-[10px] tracking-[0.3em] text-[#1E90FF] uppercase mb-5">Get in touch</div>
          <ul className="space-y-4 text-sm">
            <li>
              <a href={`tel:${BUSINESS.phoneRaw}`} className="flex items-center gap-3 text-[#A0AAB2] hover:text-white transition-colors" data-testid="footer-phone">
                <Phone className="w-4 h-4 text-[#1E90FF]" strokeWidth={1.5} /> {BUSINESS.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${BUSINESS.email}`} className="flex items-center gap-3 text-[#A0AAB2] hover:text-white transition-colors break-all" data-testid="footer-email">
                <Mail className="w-4 h-4 text-[#1E90FF] shrink-0" strokeWidth={1.5} />
                <span className="text-xs">{BUSINESS.email}</span>
              </a>
            </li>
            <li>
              <a href={BUSINESS.facebook} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-[#A0AAB2] hover:text-white transition-colors" data-testid="footer-facebook">
                <Facebook className="w-4 h-4 text-[#1E90FF]" strokeWidth={1.5} /> Facebook page
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="divider-line mb-8" />

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div className="text-xs text-[#A0AAB2]/70 tracking-wide">
          © {new Date().getFullYear()} Optima Electrical Solutions Ltd. All rights reserved.
        </div>
        <div className="text-xs text-[#A0AAB2]/70 tracking-[0.2em] uppercase">
          Medway · Kent · UK
        </div>
      </div>
    </div>
  </footer>
);
